import { render, staticRenderFns } from "./IndustrialMagazines.vue?vue&type=template&id=6fac927c&"
import script from "./IndustrialMagazines.vue?vue&type=script&lang=js&"
export * from "./IndustrialMagazines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports